import styled from 'styled-components'

export const Badge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  font-family: 'Roboto';
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #ff4d4d;
  color: white;
  font-weight: 900;
  font-size: 12px;
`
